import { render, staticRenderFns } from "./Box1.vue?vue&type=template&id=6949e20f&scoped=true&"
import script from "./Box1.vue?vue&type=script&lang=js&"
export * from "./Box1.vue?vue&type=script&lang=js&"
import style0 from "./Box1.vue?vue&type=style&index=0&id=6949e20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949e20f",
  null
  
)

export default component.exports